export const electricVehicleQuestions = [
  'iceVehicle',
  'electricVehicle',
  'vehicleUsage'
];
export const heatPumpQuestions = ['propertyId', 'heatingInsulation'];
export const solarQuestions = ['propertyId', 'electricVehicleOwnership'];

const state = {
  step: { tabIndex: 0 },
  journey: [
    'address',
    ...new Set([
      ...heatPumpQuestions,
      ...solarQuestions,
      ...electricVehicleQuestions
    ])
  ]
};

const getters = {
  progress: (state, getters, rootState, rootGetters) => {
    const journey = formatJourney(state, getters, rootState, rootGetters);
    const typeIndex = journey.indexOf(state.step);

    return ((typeIndex + 1) * 100) / journey.length;
  },
  steps: (state, getters, rootState, rootGetters) => {
    const journey = formatJourney(state, getters, rootState, rootGetters);
    const typeIndex = journey.indexOf(state.step);

    return {
      current: typeIndex + 1,
      outOf: journey.length
    };
  }
};

const actions = {
  getQuestions({ state, rootState, commit }, tabChildren) {
    const questions = tabChildren.map((child, tabIndex) => ({
      q: child.title,
      tabIndex
    }));

    if (!state.initialised) {
      commit('updateJourney', {
        questions,
        comparisonType: rootState.quote.comparisonType
      });
    }
  },
  goToQuestion({ state, rootState, rootGetters, commit }, { type }) {
    const journey = formatJourney(state, getters, rootState, rootGetters);
    const typeIndex = journey.indexOf(state.step);

    if (type === 'next') {
      if (journey.length - 1 == typeIndex) {
        // final step
        return true;
      } else {
        commit('updateState', { prop: 'step', value: journey[typeIndex + 1] });
      }
    }

    if (type === 'prev') {
      commit('updateState', { prop: 'step', value: journey[typeIndex - 1] });
    }

    if (type === 'current') {
      commit('updateState', { prop: 'step', value: journey[typeIndex] });
    }

    return false;
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  restartJourney() {
    state.step = state.journey[0];
  },
  updateJourney(state, { questions }) {
    const findQuestion = (find) => {
      return questions.find((item) => item.q === find);
    };

    state.journey = state.journey.map((item) => findQuestion(item));
    state.initialised = true;
  }
};

function formatJourney(state, getters, rootState, rootGetters) {
  const { evOnly, evCompare, ashp, solar } =
    rootState.session.quote_journey_session;
  let journey = state.journey;

  if (!state.initialised) return [];

  if (evOnly == false && evCompare == false) {
    journey = removeItemsFromJourney(journey, electricVehicleQuestions);
  } else {
    if (evCompare == false) {
      journey = removeItemsFromJourney(journey, ['iceVehicle']);
    }
  }

  if (ashp == false) {
    if (solar == true) {
      const [propertyId, ...otherQuestions] = heatPumpQuestions;
      journey = removeItemsFromJourney(journey, otherQuestions);
    }
  }

  if (solar == false) {
    if (ashp == true) {
      const [propertyId, ...otherQuestions] = solarQuestions;
      journey = removeItemsFromJourney(journey, otherQuestions);
    }
  }

  if (ashp == false && solar == false) {
    journey = removeItemsFromJourney(journey, heatPumpQuestions);
    journey = removeItemsFromJourney(journey, solarQuestions);
  }

  return journey;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function removeItemsFromJourney(array, removeList) {
  return array.filter(({ q }) => removeList.indexOf(q) === -1);
}
